import angular from 'angular';
import scheduler from './Scheduler.component';
import scheduleModal from './Schedule.modal';

export default angular.module('petroCloud.scheduler', [])
  .component(scheduler.name, scheduler)
  .component(scheduleModal.name, scheduleModal)
  .name;
